<template>
  <!-- <div class="message-box item loader">
    <div class="item">
      <div class="item">
        <span>test</span>
        <Vue3Lottie class="!w-[150px] !h-[150px]" :animationData="CupScan" />
      </div>
    </div>
  </div> -->
  <div
    v-if="loaders.firstMessage"
    class="message-box item loader -mt-[4px] !h-[38.58px]"
  >
    <Writer :speed="20" :message="{ message: ' ' }" />
  </div>
  <div
    v-if="
      allMessages[1] &&
      allMessages[1].attachments?.length > 0 &&
      allMessages[1].attachments[0]?.type === attachmentTypes.LOTTIE
    "
    class="message-box item loader"
  >
    <tempate v-for="attachment in allMessages[1].attachments">
      <div class="item" v-if="attachment.type === attachmentTypes.LOTTIE">
        <span class="block mb-3">{{ attachment.text }}</span>
        <Vue3Lottie
          v-if="attachment.link.split('/').pop() == 'reading_scan.json'"
          class="!w-[150px] !h-[150px]"
          :class="getLottieClass(attachment.link)"
          :animationData="randomScan()"
        ></Vue3Lottie>
        <Vue3Lottie
          v-if="
            attachment.link &&
            attachment.link.split('/').pop() != 'reading_scan.json'
          "
          class="!w-[150px] !h-[150px]"
          :class="getLottieClass(attachment.link)"
          :animationData="getLottiePath(attachment.link)"
        />
      </div>
    </tempate>
  </div>

  <!-- message-loader finish -->

  <!-- .all-messages start -->
  <div class="item" v-for="(item, index) in allMessages" :key="item.session_id">
    <!-- .user-message start -->
    <TimeStamp
      :timestamp="item.timestamp_t"
      v-if="
        compareMessageDates(item.timestamp, allMessages[index + 1]?.timestamp)
      "
    />
    <div v-if="item.messageType == messageTypes.USER">
      <div
        :class="
          item.userMessageType === userMessageTypes.TEXT
            ? 'message-box user'
            : 'message message-user media'
        "
      >
        <template v-if="item.userMessageType === userMessageTypes.TEXT">
          <PasswordMessage
            v-if="item.lailaMessageType === userMessageTypes.PASSWORD"
            :compData="item"
          />
          <MessageBox v-else :compData="item" />
        </template>
        <ImageMessage
          v-else-if="item.userMessageType === userMessageTypes.IMAGE"
          :compData="item"
        />
      </div>

      <ReadReceipt :compData="item" />
    </div>
    <!-- .user-message finish -->
    <!-- .chatbot-message start -->

    <div
      v-else-if="item.messageType == messageTypes.CHATBOT && item.message"
      class="message-box flex flex-col chatbot relative"
    >
      <Writer :speed="item.writerSpeed" :message="item" />

      <ShareLinks
        v-if="
          item.lailaMessageType === lailaMessageTypes.READING &&
          item.messageWriter
        "
        :withOriginalMessage="true"
        :message="item"
        :sharing="item.sharing"
      />
    </div>
    <!-- .chatbot-message finish -->

    <!-- .links start -->
    <div class="flex flex-col" v-if="item.attachments?.length > 0">
      <template v-for="attachment in item.attachments">
        <Attachment
          v-if="attachment.type"
          :attachment="attachment"
          :message="item"
        />
      </template>
    </div>

    <!-- .links finish -->
    <!-- .ready-answers start -->
    <transition name="list">
      <div
        v-if="
          item.readyAnswers &&
          item.readyAnswers.length > 0 &&
          !item.readyAnswersForReplySent &&
          item.messageWriter
        "
        class="ready-answers flex flex-col gap-[10px] items-center justify-center mt-[6px]"
      >
        <ReadyAnswers
          @handleAnswer="
            $emit('sendMessage', {
              query: answer,
              type: sendMessageTypes.readyAnswers,
              message: item,
              button: index,
            })
          "
          v-for="(answer, index) in item.readyAnswers"
          :answer="answer"
        />
      </div>
    </transition>
    <!-- .ready-answers finish -->
  </div>

  <!-- .all-messages finish -->
  <!-- .timestamp start -->
  <TimeStamp
    :timestamp="props.allMessages[props.allMessages.length - 1].timestamp_t"
    v-if="allMessages.length > 0"
  />

  <!-- .timestamp finish -->
</template>

<script setup>
  import {
    messageTypes,
    sendMessageTypes,
    userMessageTypes,
    attachmentTypes,
    lailaMessageTypes,
  } from "@/utils/enums"
  import Writer from "@/pages/components/messages/Writer.vue"
  import ReadyAnswers from "@/pages/components/messages/ReadyAnswers.vue"
  import Attachment from "@/pages/components/messages/Attachment.vue"
  import TimeStamp from "@/pages/components/messages/TimeStamp.vue"
  import ImageMessage from "@/pages/components/user/ImageMessage.vue"
  import MessageBox from "@/pages/components/user/MessageBox.vue"
  import PasswordMessage from "@/pages/components/user/PasswordMessage.vue"
  import ReadReceipt from "@/pages/components/user/ReadReceipt.vue"
  import { Vue3Lottie } from "vue3-lottie"
  import ShareLinks from "@/components/composables/ShareLinks.vue"

  import CupScan from "/public/assets/lotties/cup_scan.json"

  import ReadingScanWhite1 from "/public/assets/lotties/reading_white1.json"
  import ReadingScanWhite2 from "/public/assets/lotties/reading_white2.json"

  import ReadingScanDark1 from "/public/assets/lotties/reading_dark1.json"
  import ReadingScanDark2 from "/public/assets/lotties/reading_dark2.json"

  import QrScan from "/public/assets/lotties/qr_scan.json"
  import { userSettings } from "@/store/userSettings"
  import { watch, ref } from "vue"
  import { random } from "lodash"

  const props = defineProps({
    allMessages: {
      type: Array,
      default: [],
      required: true,
    },
    loaders: {
      type: Object,
      default: {},
      required: true,
    },
  })

  const compareMessageDates = (currDate, prevDate) => {
    if (currDate === undefined || prevDate === undefined) {
      return false
    }
    const d1 = new Date(currDate)
    const d2 = new Date(prevDate)

    return (
      d1.getFullYear() != d2.getFullYear() ||
      d1.getMonth() != d2.getMonth() ||
      d1.getDate() != d2.getDate()
    )
  }

  const lottiesWhite = ref([ReadingScanWhite1, ReadingScanWhite2])

  const lottiesDark = ref([ReadingScanDark1, ReadingScanDark2])

  const getLottiePath = (data) => {
    if (!data) return

    const caughtLottie = data.split("/").pop()
    if (caughtLottie === "cup_scan.json") return CupScan
    if (caughtLottie === "qr_scan.json") return QrScan
  }

  const randomScan = () => {
    var randomScan = Math.floor(Math.random() * 2)
    if (userSettings.userTheme == "dark") {
      return lottiesDark.value[randomScan]
    } else {
      return lottiesWhite.value[randomScan]
    }
  }

  const getLottieClass = (data) => {
    if (!data) return
    const caughtLottie = data.split("/").pop()
    if (caughtLottie === "cup_scan.json") return "cupp-scan-lottie"
    if (caughtLottie === "qr_scan.json") return "qr-scan-lottie"
    if (caughtLottie === "reading_scan.json") return "reading-scan-lottie"
  }

  const fakeSharingData = {
    title: "Fortune Teller Coffee",
    text: "Take a look at my Turkish coffee cup digitized by Fortune Teller Coffee",
    link: "https://ftc-mesh-xqc4cbw3kq-ew.a.run.app/{session_id}",
  }
</script>
